
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProductImage from '@/components/views/CmsIndex/ProductImage.vue';

@Component({
    name: 'ProductMaterialSelector',
    components: {
        ProductImage,
    },
})
export default class ProductMaterialSelector extends Vue {
    @Prop({ default: false }) private readonly isProductMaterialSelectorVisible!: boolean;

    private closeProductMaterialSelectorModal() {
        this.$emit('closeProductMaterialSelectorModal');
    }

    private openImagesModal() {
        this.$emit('openImagesModal');
        this.closeProductMaterialSelectorModal();
    }

    private openPricesModal() {
        this.$emit('openPricesModal');
        this.closeProductMaterialSelectorModal();
    }
}
